import { combineReducers } from "redux";

import scapSlice from "./creditLimitManagement/scapSlice";

const creditLimitManagementReducer = combineReducers({
	scaps: scapSlice,
});

export default creditLimitManagementReducer;
